import React from "react";

import { Card, CardTitle } from "react-md";

const RegistrationCard = ({
  title,
  subtitle,
  children,
  cardTitleClassName
  // negativeActionLabel,
  // positiveActionLabel,
  // onPositiveAction = null,
  // onNegativeAction = null,
  // enablePositiveAction = true,
  // enableNegativeAction = true,
}) => (
  <Card>
    <CardTitle
      title={title}
      subtitle={subtitle}
      className={cardTitleClassName}
    />
    {children}
    {/* {(positiveActionLabel || negativeActionLabel) &&*/}
    {/* <CardActions>*/}
    {/* <Button*/}
    {/* raised*/}
    {/* label={positiveActionLabel}*/}
    {/* className="md-block-centered"*/}
    {/* primary*/}
    {/* onClick={onPositiveAction}*/}
    {/* disabled={!enablePositiveAction}*/}
    {/* />*/}
    {/* {negativeActionLabel &&*/}
    {/* <Button*/}
    {/* raised*/}
    {/* label={negativeActionLabel}*/}
    {/* className="md-block-centered"*/}
    {/* secondary*/}
    {/* onClick={onNegativeAction}*/}
    {/* disabled={!enableNegativeAction}*/}
    {/* />}*/}
    {/* </CardActions>}*/}
  </Card>
);

export default RegistrationCard;



// WEBPACK FOOTER //
// ./src/registration/components/RegistrationCard.jsx